import { AxiosRequestConfig } from 'axios';
import instance, { PPR_API_URL } from 'api';
import { IArea, IRealEstate } from './interfaces';

export const getAreaPpr = (areaId: number) => {
  return instance(true, PPR_API_URL)
    .get<IArea>(`task/statusesByArea/${areaId}`)
    .then((response) => response.data);
};

export const getListByAreaPpr = (config?: AxiosRequestConfig) => {
  return instance(true, PPR_API_URL)
    .get<{ list: IRealEstate[]; totalCount: number }>(`task/listByArea`, config)
    .then((response) => response.data);
};
